<div class="loading-shade" *ngIf="true">
  <mat-progress-spinner mode="indeterminate" strokeWidth="3" color="accent"></mat-progress-spinner>
</div>
